import type { RouteObject } from "react-router-dom";
import { RoutesDetailsTypes } from "../entities/Route";
import Custom from "../pages/Custom";
import TasteHarmony from "../pages/TasteHarmony";
import Mixes from "../pages/Mixes";
import MixDetails from "../pages/MixDetails";
import HarmonyDetails from "../pages/HarmonyDetails/HarmonyDetails";
import CreateMix from "../pages/CreateMix/CreateMix";
import CategoriesCondiments from "../pages/CategoriesCondiments/";
import NotFound from "../pages/NotFound";

export const WebConfiguratorPath = {
  CUSTOM: "/",
  TASTE_HARMONY: "/taste-harmony",
  CATEGORIES_CONDIMENTS: "/categories-condiments/:parentId",
  MIXES: "/mixes",
  MIX_DETAILS: "mixes/:mixId",
  CATEGORY_MIX_DETAILS: "/categories-condiments/:parentId/mixes/:mixId",
  HARMONY_DETAILS: "/taste-harmony/:harmonyId",
  CREATE_MIX: "/action/edit-mix",
  NOT_FOUND: "/not-found",
};

export const RoutesDetails: RoutesDetailsTypes = {
  CUSTOM: {
    path: WebConfiguratorPath.CUSTOM,
  },
  TASTE_HARMONY: {
    path: WebConfiguratorPath.TASTE_HARMONY,
  },
  CATEGORIES_CONDIMENTS: {
    path: WebConfiguratorPath.CATEGORIES_CONDIMENTS,
  },
  MIXES: {
    path: WebConfiguratorPath.MIXES,
  },
  MIX_DETAILS: {
    path: WebConfiguratorPath.MIX_DETAILS,
  },
  CATEGORY_MIX_DETAILS: {
    path: WebConfiguratorPath.CATEGORY_MIX_DETAILS,
  },
  HARMONY_DETAILS: {
    path: WebConfiguratorPath.HARMONY_DETAILS,
  },
  CREATE_MIX: {
    path: WebConfiguratorPath.CREATE_MIX,
  },
  NOT_FOUND: {
    path: WebConfiguratorPath.NOT_FOUND,
  },
};

export const routes: RouteObject[] = [
  {
    path: RoutesDetails.CUSTOM.path,
    element: <Custom />,
  },
  {
    path: RoutesDetails.TASTE_HARMONY.path,
    element: <TasteHarmony />,
  },
  {
    path: RoutesDetails.CATEGORIES_CONDIMENTS.path,
    element: <CategoriesCondiments />,
  },
  {
    path: RoutesDetails.MIXES.path,
    element: <Mixes />,
  },
  {
    path: RoutesDetails.MIX_DETAILS.path,
    element: <MixDetails />,
  },
  {
    path: RoutesDetails.CATEGORY_MIX_DETAILS.path,
    element: <MixDetails />,
  },
  {
    path: RoutesDetails.HARMONY_DETAILS.path,
    element: <HarmonyDetails />,
  },
  {
    path: RoutesDetails.CREATE_MIX.path,
    element: <CreateMix />,
  },
  {
    path: RoutesDetails.NOT_FOUND.path,
    element: <NotFound />,
  },
];
